/*
 * tps-pff-video-kartlar.js — <tps-pff-video-kartlar>: aynı section'daki röportaj videolarından biri oynamaya başlayınca
 * diğerlerini duraklatır (iki ses üst üste binmesin). Otomatik oynatma yok; yalnız kullanıcı başlattığında devreye girer.
 * Global değişken yok; defer ile yüklenir.
 */
(() => {
  if (customElements.get('tps-pff-video-kartlar')) return;

  class TpsPffVideoKartlar extends HTMLElement {
    constructor() {
      super();
      this.videos = [];
      this.onPlay = (event) => {
        this.videos.forEach((video) => {
          if (video !== event.target && !video.paused) video.pause();
        });
      };
    }

    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.videos.forEach((video) => video.addEventListener('play', this.onPlay));
    }

    disconnectedCallback() {
      this.videos.forEach((video) => video.removeEventListener('play', this.onPlay));
      this.videos = [];
    }
  }

  customElements.define('tps-pff-video-kartlar', TpsPffVideoKartlar);
})();
